import React from 'react';

import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import CloseIcon from '../../../assets/icons/CloseIcon';
import { CustomButton } from '../../../components/UI/CustomButton';
import styled from '../../../styled';
import { colorsPalette, SMALL_MARGIN_PX } from '../../../theme';

interface LeaveModalProps {
  goBackPath: string;
  closeModal: () => void;
}

const LeaveModal: React.FC<LeaveModalProps> = ({ goBackPath, closeModal }) => {
  const { t } = useTranslation();

  return (
    <StyledContainer data-testid="leaveModal">
      <ModalContent>
        <ModalCloseBtn onClick={closeModal} />
        <Typography variant="h3">{t('page.test.leaveTitle')}</Typography>
        <ModalDescription>{t('page.test.leaveDescription')}</ModalDescription>
        <Controls>
          <Link to={goBackPath}>
            <CustomButton color="secondary">{t('button.backToPathway')}</CustomButton>
          </Link>
          <CustomButton onClick={closeModal}>{t('button.continueTest')}</CustomButton>
        </Controls>
      </ModalContent>
    </StyledContainer>
  );
};

export default LeaveModal;

const StyledContainer = styled(Box)`
  display: flex;
  align-items: center;
  height: 100vh;
`;
const ModalContent = styled(Box)`
  background: ${({ theme }) => theme.palette.secondary.main};
  border-radius: 5px;
  max-width: 590px;
  padding: 32px 24px;
  text-align: center;
`;
const ModalCloseBtn = styled(CloseIcon)`
  display: block;
  cursor: pointer;
  height: 14px;
  margin-bottom: ${SMALL_MARGIN_PX};
  margin-left: auto;
  width: 14px;
`;
const ModalDescription = styled(Typography)`
  color: ${colorsPalette.gray};
  margin: 24px 0 50px;
`;
const Controls = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;

  & > a {
    margin-bottom: 9px;
  }

  ${({ theme }) => theme.breakpoints.up('sm')} {
    flex-direction: row;
    justify-content: center;

    & > a {
      margin-bottom: 0;
      margin-right: ${SMALL_MARGIN_PX};
    }
  }
`;
